var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4939 5.06057C12.8056 5.33333 12.8372 5.80715 12.5644 6.11888C12.2917 6.43061 11.8178 6.4622 11.5061 6.18943L9.75 4.65283V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V4.65283L6.49388 6.18943C6.18215 6.4622 5.70833 6.43061 5.43557 6.11888C5.16281 5.80715 5.19439 5.33333 5.50612 5.06057L8.50612 2.43557C8.78889 2.18814 9.21111 2.18814 9.49388 2.43557L12.4939 5.06057ZM3 12C3 11.5858 2.66421 11.25 2.25 11.25C1.83579 11.25 1.5 11.5858 1.5 12V14.25C1.5 15.0784 2.17157 15.75 3 15.75H15C15.8284 15.75 16.5 15.0784 16.5 14.25V12C16.5 11.5858 16.1642 11.25 15.75 11.25C15.3358 11.25 15 11.5858 15 12V14.25H3V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.d05e849e180f8ca1f3c9acaaa640f2db.svg";
export { ForwardRef as ReactComponent };